import { render, staticRenderFns } from "./CreateGlobalMessage.vue?vue&type=template&id=75e62bdc&scoped=true"
import script from "./CreateGlobalMessage.vue?vue&type=script&lang=js"
export * from "./CreateGlobalMessage.vue?vue&type=script&lang=js"
import style0 from "./CreateGlobalMessage.vue?vue&type=style&index=0&id=75e62bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e62bdc",
  null
  
)

export default component.exports